import { render, staticRenderFns } from "./OrganismSpaceDetails.vue?vue&type=template&id=5cad5343&"
import script from "./OrganismSpaceDetails.vue?vue&type=script&lang=js&"
export * from "./OrganismSpaceDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrganismSpaceDetails.vue?vue&type=style&index=0&id=5cad5343&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/OrganismSpaceDetails.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Forganisms%2Fcommon%2Favailability%2FOrganismSpaceDetails.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomInfoPrice: require('/app/components/atoms/common/AtomInfoPrice.vue').default,AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomButton: require('/app/components/atoms/common/AtomButton.vue').default,OrganismsCommonOrganismDrawer: require('/app/components/organisms/common/OrganismDrawer.vue').default})
